import React, { useState, useEffect } from 'react';

function ShopPage({ preselectedCategory }) {
  const [selectedCategory, setSelectedCategory] = useState(preselectedCategory || null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState('aroma');

  useEffect(() => {
    if (preselectedCategory) {
      setSelectedCategory(preselectedCategory);
    }
  }, [preselectedCategory]);

  const categories = ['aromas', 'difusores'];
  
  const filters = {
    aroma: ['Tropicales', 'Frutales', 'Cítricas', 'Florales', 'Amaderadas', 'Orientales'],
    familia: ['Amaderada', 'Floral', 'Cítrica', 'Oriental', 'Frutal', 'Primavera-Verano', 'Otoño-Invierno']
  };

  const productVariants = {
    aroma: { 
      name: 'Aroma Ambiental', 
      price: 300,
      image: '/images/products/aceitearomatico.jpeg'
    },
    perfume: { 
      name: 'Perfume', 
      price: 350,
      image: '/images/products/perfumeind.jpeg'
    },
    vela: { 
      name: 'Vela Aromática', 
      price: 500,
      image: '/images/products/velas.jpeg'
    },
    difusorBlanco: {
      name: 'Difusor Blanco',
      price: 2200,
      image: '/images/products/difblanco.jpeg'
    },
    difusorNegro: {
      name: 'Difusor Negro',
      price: 2200,
      image: '/images/products/difnegro.jpeg'
    }
  };

  const products = [
    // Fragancias Amaderadas
    {
      id: 101,
      name: 'Pachulí',
      familia: 'Amaderada',
      componentes: ['pachulí', 'cacao', 'leña', 'tabaco'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Una fragancia profunda y misteriosa con notas amaderadas'
    },
    {
      id: 102,
      name: 'Rosa & Fine',
      familia: 'Amaderada',
      componentes: ['nectarina', 'peonia', 'lilies', 'cachemira'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Elegancia floral con toques amaderados'
    },
    {
      id: 103,
      name: 'Sándalo',
      familia: 'Amaderada',
      componentes: ['sándalo', 'rosa', 'ambar', 'amizcle'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
        {
      id: 104,
      name: 'Bulgy Car Man',
      familia: 'Amaderada',
      componentes: ['Citrico', 'Fressia', 'Almizcle', 'Sandalo'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
        {
      id: 105,
      name: 'Dark Tea Xcaret',
      familia: 'Amaderada',
      componentes: ['Ciprés', 'Limón', 'Madera Exótica', 'Ambar'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
        {
      id: 106,
      name: 'Cedarwood',
      familia: 'Amaderada',
      componentes: ['Ciprés', 'Limón', 'Madera Exótica', 'Ambar'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
            {
      id: 107,
      name: 'Luxury Cedarwood',
      familia: 'Amaderada',
      componentes: ['Ciprés', 'Limón', 'Madera Exótica', 'Vetiver'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
            {
      id: 108,
      name: 'Mahogany Tealwood',
      familia: 'Amaderada',
      componentes: ['Limón', 'Lavandín', 'Violeta', 'Tonka'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
            {
      id: 109,
      name: 'Palo Santo',
      familia: 'Amaderada',
      componentes: ['Palo Santo', 'Palmarosa', 'Citrico', 'Maderas'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
                {
      id: 110,
      name: 'Air D Parfum',
      familia: 'Amaderada',
      componentes: ['Floral', 'Maderas', 'Almizcle', 'Dulce'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
                {
      id: 111,
      name: 'Aria',
      familia: 'Amaderada',
      componentes: ['Gardenia', 'Madera Blanca', 'Vainilla', 'Jazmin'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
                {
      id: 112,
      name: 'Gardenia',
      familia: 'Amaderada',
      componentes: ['Gardenia', 'Clavo', 'Flor de azahar', 'Cedro'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Calidez envolvente con sándalo y ambar'
    },
    // Fragancias Florales
    {
      id: 201,
      name: 'Japanese Lotus Flowers',
      familia: 'Floral',
      componentes: ['flor de loto', 'jazmín', 'almizcle', 'madera'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Delicada fragancia floral con esencia de loto japonés'
    },
    {
      id: 202,
      name: 'Jazmín Air',
      familia: 'Floral',
      componentes: ['jazmín', 'flor de azahar', 'almizcle', 'ámbar'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia romántica con notas de jazmín envolvente'
    },
    {
      id: 203,
      name: 'Lavanda',
      familia: 'Floral',
      componentes: ['lavanda', 'menta', 'salvia', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Aroma relajante y fresco con lavanda pura'
    },
    {
      id: 204,
      name: 'Lila Bloom',
      familia: 'Floral',
      componentes: ['lirio del valle', 'lavanda', 'té verde', 'bergamota'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia suave y elegante con lilas en flor'
    },
    {
      id: 205,
      name: 'Mullberries & Magnolia',
      familia: 'Floral',
      componentes: ['moras', 'magnolia', 'pimienta rosa', 'pachoulí'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Combinación única de frutas y flores exóticas'
    },
    {
      id: 206,
      name: 'Ylang Ylang',
      familia: 'Floral',
      componentes: ['ylang ylang', 'coco', 'vainilla', 'muguete'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Aroma tropical y sensual con ylang ylang exótico'
    },
    // Fragancias Cítricas
    {
      id: 301,
      name: 'Basil Rain',
      familia: 'Cítrica',
      componentes: ['menta', 'jazmín', 'albahaca', 'ámbar'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Frescura herbal con toque de lluvia y albahaca'
    },
    {
      id: 302,
      name: 'Citric Jazmin',
      familia: 'Cítrica',
      componentes: ['limón', 'naranja', 'jazmín', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Mezcla vibrante de cítricos con jazmín delicado'
    },
    {
      id: 303,
      name: 'Eucalipto',
      familia: 'Cítrica',
      componentes: ['eucalipto', 'pino', 'romero', 'cedro'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Aroma refrescante y purificador con eucalipto'
    },
    {
      id: 304,
      name: 'Fairy Dust',
      familia: 'Cítrica',
      componentes: ['eucalipto', 'lavanda', 'musgo', 'cedro'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia mágica y fresca con toques boscosos'
    },
    {
      id: 305,
      name: 'Green Tea',
      familia: 'Cítrica',
      componentes: ['bergamota', 'mandarina', 'té', 'musgo'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Aroma zen y revitalizante de té verde'
    },
    {
      id: 306,
      name: 'Green Te & Bergamota',
      familia: 'Cítrica',
      componentes: ['bergamota', 'mandarina', 'té verde', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Elegante combinación de té y bergamota'
    },
    {
      id: 307,
      name: 'Lime & Mandarine',
      familia: 'Cítrica',
      componentes: ['limón verde', 'mandarina', 'albahaca', 'vetiver'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Explosión cítrica inspirada en Jo Malone'
    },
    {
      id: 308,
      name: 'Rivera',
      familia: 'Cítrica',
      componentes: ['limón', 'lavanda', 'neroli', 'tonka'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia de lujo inspirada en Hotel Grand Bliss'
    },
    {
      id: 309,
      name: 'Morevo',
      familia: 'Cítrica',
      componentes: ['naranja', 'pomelo', 'eucalipto', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Cítricos frescos con toque amaderado'
    },
    {
      id: 310,
      name: 'Nayaro',
      familia: 'Cítrica',
      componentes: ['mandarina', 'cáscara de cítricos', 'jazmín', 'pachulí'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia cítrica con toques florales y amaderados'
    },
    {
      id: 311,
      name: 'Tangerine & Fig',
      familia: 'Cítrica',
      componentes: ['tangarina', 'higo', 'jazmín', 'ámbar'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Inspirada en Innova Sport - Cítricos con higo'
    },
    {
      id: 312,
      name: 'Te Blanco y Te Verde',
      familia: 'Cítrica',
      componentes: ['bergamota', 'limón', 'ozónico', 'ámbar'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Combinación refrescante de tés aromáticos'
    },
    {
      id: 313,
      name: 'Toronja',
      familia: 'Cítrica',
      componentes: ['lima', 'manzana', 'toronja', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Explosión fresca de toronja y cítricos'
    },
    {
      id: 314,
      name: 'Turquesa Rock',
      familia: 'Cítrica',
      componentes: ['bergamota', 'salvia', 'lavanda', 'maderas'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia fresca con toques herbales y amaderados'
    },
    {
      id: 315,
      name: 'Verbena y Te Verde',
      familia: 'Cítrica',
      componentes: ['verbena', 'limón', 'lemon grass', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Aroma energizante de verbena y té verde'
    },
    {
      id: 316,
      name: 'Vidanta',
      familia: 'Cítrica',
      componentes: ['pomelo', 'té', 'neroli', 'tonka'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Inspirada en Hotel Myera Maya - Lujo cítrico'
    },
    {
      id: 317,
      name: 'White Palm',
      familia: 'Cítrica',
      componentes: ['naranja', 'magnolia', 'melocotón', 'vetiver'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Hotel Collection - Elegancia cítrica floral'
    },
    {
      id: 318,
      name: 'White Tea & Ginger',
      familia: 'Cítrica',
      componentes: ['bergamota', 'cítricos', 'pomelo', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Tienda Metropolitan - Té blanco especiado'
    },
    {
      id: 319,
      name: 'Wyn Vegas',
      familia: 'Cítrica',
      componentes: ['bambú', 'verbena', 'flor de loto', 'lirio del valle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Aroma zen con notas florales y cítricas'
    },
    // Fragancias Frutales
    {
      id: 401,
      name: 'Berrys',
      familia: 'Frutal',
      componentes: ['manzana', 'bayas', 'frambuesa', 'flor de azahar'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Tienda Muy Muchos - Explosión de frutos rojos'
    },
    {
      id: 402,
      name: 'Cactus & Sweet Pitaya',
      familia: 'Frutal',
      componentes: ['pera', 'manzana', 'pitaya', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia tropical con pitaya exótica'
    },
    {
      id: 403,
      name: 'Cherry Blossom Micado',
      familia: 'Frutal',
      componentes: ['cereza', 'piña', 'rosa', 'caramelo'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Tienda Muy Muchos - Dulzura de cerezas en flor'
    },
    {
      id: 404,
      name: 'Honeyed Fig',
      familia: 'Frutal',
      componentes: ['higo', 'fruta', 'musgo', 'leña'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Higos acaramelados con toques amaderados'
    },
    {
      id: 405,
      name: 'Morning Sun',
      familia: 'Frutal',
      componentes: ['manzana roja', 'cereza negra', 'mango', 'caramelo'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Despierta con frutas jugosas y dulces'
    },
    {
      id: 406,
      name: 'Redkiss',
      familia: 'Frutal',
      componentes: ['frutos rojos', 'melón', 'dulce', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Beso de frutas rojas irresistibles'
    },
    {
      id: 407,
      name: 'Velver Peach',
      familia: 'Frutal',
      componentes: ['melocotón', 'limón', 'osmanto', 'vainilla'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Durazno aterciopelado con notas florales'
    },
    {
      id: 408,
      name: 'Zerena',
      familia: 'Frutal',
      componentes: ['manzana', 'lichi', 'caramelo', 'cedro'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Manzana caramelizada con lichi exótico'
    },
    // Fragancias Orientales
    {
      id: 501,
      name: 'Amber Dark',
      familia: 'Oriental',
      componentes: ['naranja', 'violeta', 'ylang ylang', 'ámbar'],
      tipo: 'Unisex',
      aroma: 'Orientales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Tienda Zara Home - Ámbar oscuro y seductor'
    },
    {
      id: 502,
      name: 'Cardamom Fresh',
      familia: 'Oriental',
      componentes: ['cítricos', 'especias', 'almizcle', 'maderas'],
      tipo: 'Unisex',
      aroma: 'Orientales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Cardamomo fresco con especias orientales'
    },
    {
      id: 503,
      name: 'Shizen',
      familia: 'Oriental',
      componentes: ['rosa', 'frutos rojos', 'incienso', 'cuero'],
      tipo: 'Unisex',
      aroma: 'Orientales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fragancia mística con incienso y cuero'
    },
    // Fragancias Primavera-Verano
    {
      id: 601,
      name: 'Gin Tonic Mixologia',
      familia: 'Primavera-Verano',
      componentes: ['bergamota', 'eucalipto', 'sándalo', 'pachulí'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Refrescante como un gin tonic en verano'
    },
    {
      id: 602,
      name: 'Golden Chic',
      familia: 'Primavera-Verano',
      componentes: ['pepino', 'jazmín', 'guayaba', 'vetiver'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Palacio de Hierro - Elegancia dorada y fresca'
    },
    {
      id: 603,
      name: 'Hemp Speed & Gren Roots',
      familia: 'Primavera-Verano',
      componentes: ['semilla de cáñamo', 'canela', 'limón', 'maderas exóticas'],
      tipo: 'Unisex',
      aroma: 'Amaderadas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Energía natural con raíces verdes'
    },
    {
      id: 604,
      name: 'Kaleidoscope',
      familia: 'Primavera-Verano',
      componentes: ['manzana', 'pera', 'neroli', 'ámbar'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Colores y aromas que cambian como un caleidoscopio'
    },
    {
      id: 605,
      name: 'Lino',
      familia: 'Primavera-Verano',
      componentes: ['cítricos', 'fresco', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Limpio y fresco como ropa de lino'
    },
    {
      id: 606,
      name: 'Mai Tai Mixologia',
      familia: 'Primavera-Verano',
      componentes: ['geranio', 'rosa', 'violeta', 'vainilla'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Cóctel tropical floral y dulce'
    },
    {
      id: 607,
      name: 'Moscow Mule Mixologia',
      familia: 'Primavera-Verano',
      componentes: ['lima', 'higo', 'coco', 'haba tonka'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Fresco y picante como el cóctel clásico'
    },
    {
      id: 608,
      name: 'One Bamboo',
      familia: 'Primavera-Verano',
      componentes: ['bambú', 'lirio del valle', 'musgo', 'talco'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Zen y puro como el bambú'
    },
    {
      id: 609,
      name: 'Rose Water Ivy',
      familia: 'Primavera-Verano',
      componentes: ['guayaba', 'melocotón', 'rosa', 'tonka'],
      tipo: 'Unisex',
      aroma: 'Florales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Agua de rosas con frutas jugosas'
    },
    {
      id: 610,
      name: 'Straw Berry Champagne',
      familia: 'Primavera-Verano',
      componentes: ['grosella negra', 'rosa', 'frambuesa', 'almizcle'],
      tipo: 'Unisex',
      aroma: 'Frutales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Burbujeante como champagne con fresas'
    },
    {
      id: 611,
      name: 'Vainilla Coconut Hawaii',
      familia: 'Primavera-Verano',
      componentes: ['coco', 'piña', 'vainilla', 'sándalo'],
      tipo: 'Unisex',
      aroma: 'Tropicales',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Escapada tropical a Hawaii'
    },
    {
      id: 612,
      name: 'White Tea',
      familia: 'Primavera-Verano',
      componentes: ['eucalipto', 'té', 'jengibre', 'vetiver'],
      tipo: 'Unisex',
      aroma: 'Cítricas',
      image: '/images/products/prodgeneral.jpeg',
      description: 'Té blanco purificante y refrescante'
    },
    {
    id: 701,
    name: 'Apple Pie',
    familia: 'Especiada / Dulce',
    componentes: ['manzana roja', 'canela', 'dulce'],
    tipo: 'Unisex',
    aroma: 'Frutal Especiado',
    image: '/images/products/prodgeneral.jpeg',
    description: 'El cálido y reconfortante aroma de una tarta de manzana recién horneada con toques de canela.'
  },
  {
    id: 702,
    name: 'Autum Spice',
    familia: 'Especiada / Floral',
    componentes: ['cardamomo', 'frambuesa', 'iris', 'almizcle'],
    tipo: 'Unisex',
    aroma: 'Especiado Floral',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una mezcla sofisticada de especias otoñales con la suavidad del iris y un fondo de almizcle.'
  },
  {
    id: 703,
    name: 'Celebration Wine',
    familia: 'Frutal / Floral',
    componentes: ['manzana', 'melocoton', 'magnolia', 'vainilla'],
    tipo: 'Femenino',
    aroma: 'Frutal Dulce',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una fragancia festiva que combina frutas dulces con la elegancia de la magnolia y vainilla.'
  },
  {
    id: 704,
    name: 'Dicken Christmas',
    familia: 'Especiada / Frutal',
    componentes: ['canela', 'clavo', 'ciruela', 'almizcle'],
    tipo: 'Unisex',
    aroma: 'Navideño Tradicional',
    image: '/images/products/prodgeneral.jpeg',
    description: 'La esencia clásica de la navidad: especias fuertes y ciruelas maduras.'
  },
  {
    id: 705,
    name: 'French Vainilla',
    familia: 'Dulce / Gourmet',
    componentes: ['coco', 'nuez', 'vainilla', 'caramelo'],
    tipo: 'Unisex',
    aroma: 'Dulce Cremoso',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Un aroma rico y envolvente con notas de vainilla francesa, coco y nueces tostadas.'
  },
  {
    id: 706,
    name: 'Crema de Oro',
    familia: 'Gourmet',
    componentes: ['chocolate', 'licor', 'caramelo', 'salado'],
    tipo: 'Unisex',
    aroma: 'Dulce Intenso',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una fragancia indulgente que evoca bombones de chocolate con licor y caramelo salado.'
  },
  {
    id: 707,
    name: 'Holley Berry',
    familia: 'Frutal / Dulce',
    componentes: ['frutos rojos', 'mermelada', 'vainilla', 'mantequilla'],
    tipo: 'Femenino',
    aroma: 'Frutal Gourmet',
    image: '/images/products/prodgeneral.jpeg',
    description: 'El aroma dulce de las bayas de invierno convertidas en mermelada con un toque mantecoso.'
  },
  {
    id: 708,
    name: 'Night Juniper',
    familia: 'Amaderada / Floral',
    componentes: ['melocoton', 'rosa', 'cedro', 'sandalo'],
    tipo: 'Unisex',
    aroma: 'Amaderado Floral',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una fragancia nocturna y elegante con maderas de cedro y sándalo suavizadas por rosas.'
  },
  {
    id: 709,
    name: 'Pumpkin & Gringbread',
    familia: 'Especiada / Gourmet',
    componentes: ['naranja', 'canela', 'clavo', 'calabaza'],
    tipo: 'Unisex',
    aroma: 'Especiado Cálido',
    image: '/images/products/prodgeneral.jpeg',
    description: 'La combinación perfecta de calabaza y especias de jengibre para los días más fríos.'
  },
  {
    id: 710,
    name: 'Santa´s Secret',
    familia: 'Frutal / Amaderada',
    componentes: ['piña', 'cardamomo', 'cedro', 'musgo'],
    tipo: 'Masculino',
    aroma: 'Bosque Tropical',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Un secreto fresco y terroso que mezcla la vitalidad de la piña con el musgo del bosque.'
  },
  {
    id: 711,
    name: 'Snowflakes',
    familia: 'Cítrica / Floral',
    componentes: ['naranja', 'coco', 'violeta', 'vainilla'],
    tipo: 'Femenino',
    aroma: 'Fresco Dulce',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una fragancia limpia y suave como la nieve, con destellos cítricos y flores dulces.'
  },
  {
    id: 712,
    name: 'Swiss Apple Pine',
    familia: 'Herbal / Amaderada',
    componentes: ['menta', 'pino', 'canela', 'maderas'],
    tipo: 'Unisex',
    aroma: 'Fresco Invernal',
    image: '/images/products/prodgeneral.jpeg',
    description: 'El aire puro de los Alpes: pinos frescos, menta refrescante y maderas cálidas.'
  },
  {
    id: 713,
    name: 'Velour Frost',
    familia: 'Amaderada / Especiada',
    componentes: ['sandalo', 'clavo de olor', 'humo', 'cedro'],
    tipo: 'Masculino',
    aroma: 'Ahumado Amaderado',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una fragancia intensa y ahumada con un carácter profundamente maderoso.'
  },
  {
    id: 714,
    name: 'Velvet Cozy',
    familia: 'Frutal / Especiada',
    componentes: ['bayas silvestres', 'especias', 'maderas', 'almizcle'],
    tipo: 'Unisex',
    aroma: 'Suave Especiado',
    image: '/images/products/prodgeneral.jpeg',
    description: 'La sensación de una manta aterciopelada con notas de bayas y especias suaves.'
  },
  {
    id: 715,
    name: 'Xmas Bonfire',
    familia: 'Cítrica / Amaderada',
    componentes: ['citricos', 'rosa', 'canela', 'maderas'],
    tipo: 'Unisex',
    aroma: 'Cálido Cítrico',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Evoca una fogata navideña con cáscaras de cítricos y leña quemándose.'
  },
  {
    id: 716,
    name: 'Xmas Cheers',
    familia: 'Gourmet / Licorosa',
    componentes: ['coco', 'vino tinto', 'tonka', 'vainilla'],
    tipo: 'Unisex',
    aroma: 'Dulce Licoroso',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Un brindis festivo de vino tinto y haba tonka sobre una base cremosa de coco.'
  },
  {
    id: 717,
    name: 'Wish Pears of Gold',
    familia: 'Especiada / Amaderada',
    componentes: ['tabaco', 'vainilla', 'jengibre', 'citricos'],
    tipo: 'Masculino',
    aroma: 'Especiado Elegante',
    image: '/images/products/prodgeneral.jpeg',
    description: 'Una fragancia elegante y poderosa con tabaco, jengibre y un toque de vainilla.'
  },
  // Difusores Aromáticos
  {
    id: 801,
    name: 'Difusor Premium',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Tanque de 400mL','Programacion por aplicacion','Conexion electrica'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    image: '/images/products/DifusorPremium.jpeg',
    description: 'Ideal para espacios pequeños. Tecnología de atomización de dos fluidos para una difusión uniforme. Funcionamiento silencioso con un nivel de ruido de 36-45 dBA. Duración de 1 mes o más dependiendo de la frecuencia e intensidad. Tanque de 400ml incluido. Disponible en color blanco y negro.'
  },
  {
    id: 802,
    name: 'Scent Diffuser 3000',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Control por aplicacion', 'Programacion en intervalos de tiempo', 'Recargable', 'Capacidad de 800ml','Cobertura de 600m²'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 6600,
    image: '/images/products/ScenDiffuser3000.jpeg',
    description: 'Para espacios grandes salas de estar grandes, consultorios grandes, crea ambientes relajantes y armonizantes.'
  },
  {
    id: 803,
    name: 'Scent Diffuser 300',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Control por aplicacion','Programacion en intervalos de tiempo','Capacidad de 200ml','Cobertura de 160m²', 'Recargable'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 3900,
    image: '/images/products/ScentDiffuser300.jpeg',
    description: 'Para habitaciones, salas de estar, con estilo moderno'
  },
    {
    id: 804,
    name: 'Vertical Smart Diffuser',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Panel con control digital','Capacidad de 800ml','Control con aplicacion','Se conecta a la luz'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 7800,
    image: '/images/products/VerticalSmartDiffuser.jpeg',
    description: 'Para departamentos grandes, salas o estancias, pisos corporativos o departamentales.'
  },
    {
    id: 805,
    name: 'Aroma Diffuser',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Contorl por aplicacion','Capacidad de 120ml','Cobertura de 100m²','Recargable'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 4400,
    image: '/images/products/AromaDiffuser.jpeg',
    description: 'Ideal para oficinas, salas, cocinas, spas, y espacios pequeños a medianos en general'
  },
    {
    id: 806,
    name: 'M22 Diffuser',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Capacidad de 10ml','Cobertura de 30m²', 'Programacion en intervalos de tiempo'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 1500,
    image: '/images/products/M22Diffuser.jpeg',
    description: 'Ideal para oficinas pequeñas, consultorios, slas de espera entre otros.'
  },
      {
    id: 807,
    name: 'Portable Plug-in Diffuser',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Sensor de aro de luz','Panel de control','Diseño discreto','Capacidad de 10ml','Cobertura de 10m²'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 1700,
    image: '/images/products/PortablePlugDiffuser.jpeg',
    description: 'Ideal para baños, recamaras, salas de estar, estudios y espacios pequeños en general'
  },
      {
    id: 808,
    name: 'Car Diffuser',
    category: 'difusores',
    familia: 'Difusor Aromático',
    componentes: ['Capacidad de 20mL','Recargable','Cobertura de espacio personal'],
    tipo: 'Unisex',
    aroma: 'Difusor',
    oldProduct: true,
    price: 950,
    image: '/images/products/CarDiffuser.jpeg',
    description: 'Ideal para interiores de vehiculos o areas pequenas como cubiculos o salas de juntas.'
  },
  ];

  const toggleFilter = (filterType, value) => {
    const filterKey = `${filterType}:${value}`;
    setSelectedFilters(prev => 
      prev.includes(filterKey) 
        ? prev.filter(f => f !== filterKey)
        : [...prev, filterKey]
    );
  };

  const filteredProducts = products.filter(product => {
    // Filtro por categoría
    if (selectedCategory) {
      if (selectedCategory === 'aromas' && product.category === 'difusores') {
        return false;
      }
      if (selectedCategory === 'difusores' && product.category !== 'difusores') {
        return false;
      }
    }

    // Filtro por búsqueda
    if (searchTerm && !product.name.toLowerCase().includes(searchTerm.toLowerCase())) {
      return false;
    }

    // Filtros adicionales
    if (selectedFilters.length > 0) {
      return selectedFilters.every(filter => {
        const [type, value] = filter.split(':');
        return product[type] === value;
      });
    }

    return true;
  });

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    // Establecer la variante inicial según el tipo de producto
    if (product.category === 'difusores') {
      setSelectedVariant('difusorBlanco');
    } else {
      setSelectedVariant('aroma');
    }
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  const getCurrentPrice = () => {
    if (!selectedProduct) return 0;
    if (selectedProduct.oldProduct) return selectedProduct.price;
    return productVariants[selectedVariant].price;
  };

  const sendWhatsAppMessage = () => {
    if (!selectedProduct) return;
    
    let message = `Hola, me interesa la fragancia:%0A%0A`;
    message += `*${selectedProduct.name}*%0A`;
    
    if (selectedProduct.familia) {
      message += `Familia: ${selectedProduct.familia}%0A`;
    }
    
    if (selectedProduct.componentes) {
      message += `Componentes: ${selectedProduct.componentes.join(', ')}%0A`;
    }
    
    if (!selectedProduct.oldProduct) {
      message += `%0ATipo: ${productVariants[selectedVariant].name}%0A`;
      message += `Precio: MXN$${productVariants[selectedVariant].price}`;
    } else {
      message += `%0APrecio: MXN$${selectedProduct.price}`;
    }
    
    const phoneNumber = '5218123225278';
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  };

  return (
    <section className="shop-page">
      <div className="shop-header">
        <h1>Descubre perfumes inspirados en diseñadores y creados en Francia</h1>
        
        <div className="search-bar">
          <input 
            type="text" 
            placeholder="Busca notas aromáticas, marcas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="search-btn">🔍</button>
        </div>

        <div className="category-tabs">
          <button 
            className={!selectedCategory ? 'active' : ''}
            onClick={() => setSelectedCategory(null)}
          >
            Todos
          </button>
          {categories.map(cat => (
            <button 
              key={cat}
              className={selectedCategory === cat ? 'active' : ''}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="shop-content">
        <aside className="shop-filters">
          <div className="filter-section">
            <h3>Familia</h3>
            {filters.familia.map(familia => (
              <label key={familia} className="filter-option">
                <input 
                  type="checkbox"
                  checked={selectedFilters.includes(`familia:${familia}`)}
                  onChange={() => toggleFilter('familia', familia)}
                />
                <span>{familia}</span>
              </label>
            ))}
          </div>

          <div className="filter-section">
            <h3>Tipo de Aroma</h3>
            {filters.aroma.map(aroma => (
              <label key={aroma} className="filter-option">
                <input 
                  type="checkbox"
                  checked={selectedFilters.includes(`aroma:${aroma}`)}
                  onChange={() => toggleFilter('aroma', aroma)}
                />
                <span>{aroma}</span>
              </label>
            ))}
          </div>

          {selectedFilters.length > 0 && (
            <button 
              className="clear-filters"
              onClick={() => setSelectedFilters([])}
            >
              Limpiar filtros
            </button>
          )}
        </aside>

        <div className="shop-products">
          <div className="products-grid">
            {filteredProducts.map(product => (
              <div 
                key={product.id} 
                className="product-card"
                onClick={() => handleProductClick(product)}
                style={{ cursor: 'pointer' }}
              >
                <div className="product-badges">
                  <span className="badge-category">{product.tipo}</span>
                  {product.familia && <span className="badge-familia">{product.familia}</span>}
                  {product.reviews > 3000 && <span className="badge-popular">Más vendido</span>}
                  {product.isSpecialOffer && <span className="badge-special">💼 Combo Especial</span>}
                </div>
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-info">
                  {product.rating && (
                    <div className="product-rating">
                      {'★'.repeat(Math.floor(product.rating))}
                      {'☆'.repeat(5 - Math.floor(product.rating))}
                      <span className="reviews-count">{product.reviews}</span>
                    </div>
                  )}
                  <h3 className="product-name">{product.name}</h3>
                  {product.oldProduct ? (
                    <p className="product-price">MXN${product.price}</p>
                  ) : product.category === 'difusores' ? (
                    <p className="product-price">MXN$2200</p>
                  ) : (
                    <p className="product-price">Desde MXN$300</p>
                  )}
                  {product.componentes && (
                    <p className="product-components">
                      {product.componentes.slice(0, 3).join(', ')}
                      {product.componentes.length > 3 && '...'}
                    </p>
                  )}
                  {product.inspirado && (
                    <p className="product-inspired">Inspirado en <strong>{product.inspirado}</strong></p>
                  )}
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-results">
              <p>No se encontraron productos con los filtros seleccionados</p>
            </div>
          )}
        </div>
      </div>

      {/* Modal de Detalles del Producto */}
      {selectedProduct && (
        <div className="product-modal-overlay" onClick={closeModal}>
          <div className="product-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>✕</button>
            
            <div className="modal-content">
              <div className="modal-image-section">
                <div className="modal-image">
                  <img 
                    src={selectedProduct.oldProduct ? selectedProduct.image : productVariants[selectedVariant].image} 
                    alt={selectedProduct.name} 
                  />
                </div>
                
                {!selectedProduct.oldProduct && (
                  <div className="variant-thumbnails">
                    {Object.entries(productVariants)
                      .filter(([key]) => {
                        // Filtrar variantes según el tipo de producto
                        if (selectedProduct.category === 'difusores') {
                          return key.startsWith('difusor');
                        } else {
                          return !key.startsWith('difusor');
                        }
                      })
                      .map(([key, variant]) => (
                      <div 
                        key={key}
                        className={`variant-thumb ${selectedVariant === key ? 'active' : ''}`}
                        onClick={() => setSelectedVariant(key)}
                      >
                        <img src={variant.image} alt={variant.name} />
                        <span>{variant.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              <div className="modal-details">
                <h2>{selectedProduct.name}</h2>
                
                {selectedProduct.familia && (
                  <p className="modal-familia">
                    <strong>Familia:</strong> {selectedProduct.familia}
                  </p>
                )}
                
                {selectedProduct.componentes && (
                  <div className="modal-components">
                    <strong>{selectedProduct.isSpecialOffer ? 'Incluye:' : 'Componentes:'}</strong>
                    <ul>
                      {selectedProduct.componentes.map((comp, index) => (
                        <li key={index}>{selectedProduct.isSpecialOffer ? `✔️ ${comp}` : comp}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                {selectedProduct.description && (
                  <p className="modal-description">{selectedProduct.description}</p>
                )}
                
                {!selectedProduct.oldProduct ? (
                  <div className="modal-variant-selector">
                    <label htmlFor="variant-select">
                      <strong>Selecciona el tipo:</strong>
                    </label>
                    <select 
                      id="variant-select"
                      value={selectedVariant}
                      onChange={(e) => setSelectedVariant(e.target.value)}
                    >
                      {Object.entries(productVariants)
                        .filter(([key]) => {
                          // Filtrar variantes según el tipo de producto
                          if (selectedProduct.category === 'difusores') {
                            return key.startsWith('difusor');
                          } else {
                            return !key.startsWith('difusor');
                          }
                        })
                        .map(([key, variant]) => (
                        <option key={key} value={key}>
                          {variant.name} - MXN${variant.price}
                        </option>
                      ))}
                    </select>
                    
                    <div className="modal-price">
                      <strong>Precio:</strong> MXN${getCurrentPrice()}
                    </div>
                  </div>
                ) : (
                  <div className="modal-price">
                    <strong>Precio:</strong> MXN${selectedProduct.price}
                  </div>
                )}
                
                <button className="add-to-cart-btn" onClick={sendWhatsAppMessage}>
                  💬 Pedir por WhatsApp
                </button>
                
                {selectedProduct.inspirado && (
                  <p className="modal-inspired">
                    <em>Inspirado en {selectedProduct.inspirado}</em>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default ShopPage;
